<template>
  <HvhModal title="Patient Timeline Data" :value="!!value" maxWidth="400px" @input="$emit('input', null)" v-if="value">
    <div>
      <div>
        <b>{{ value.description }}</b>
      </div>
      <div>
        % of Patients: <b>{{ percentages(value.patientPercentage / 100) }}</b>
      </div>
      <div>
        % of Females: <b>{{ percentages(value.femaleCount / cohortCount) }}</b>
      </div>
      <div>
        Average Age: <b>{{ number(value.totalAge / patientCount) }}</b>
      </div>
      <div>
        % Commercial: <b>{{ percentages(value.commercialInsCount / cohortCount) }}</b>
      </div>
      <div>
        % Other Insurance: <b>{{ percentages(value.otherInsCount / cohortCount) }}</b>
      </div>
      <div>
        % Medicare: <b>{{ percentages(value.medicareInsCount / cohortCount) }}</b>
      </div>
      <div>
        % Medicaid: <b>{{ percentages(value.medicaidInsCount / cohortCount) }}</b>
      </div>
    </div>
  </HvhModal>
</template>

<script>
import { valueDisplayFormat } from '../../libraries/common';
export default {
  props: ['value'],
  computed: {
    cohortCount() {
      return this.value?.cohortCount;
    },
    patientCount() {
      return this.value?.patientCount;
    },
  },
  methods: {
    percentages: valueDisplayFormat.percentages,
    number: valueDisplayFormat.number,
  },
}
</script>